import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import logo from 'assets/img/bewiseapp/logo.png';

const PrintHeader = ({ order }) => {
  const currentDate = new Date().toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  return (
    <Box className="print-only print-header" sx={{ mb: 1 }}>
      <Box textAlign="center" mb={1}>
        <Box display="flex" justifyContent="center" mb={0.5}>
          <img 
            src={logo} 
            alt="BeWise" 
            style={{ 
              height: 60, 
              maxWidth: '200px',
              objectFit: 'contain'
            }} 
          />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#000', mb: 0.25 }}>
          Order {order?.order_identifier || order?.id || 'N/A'}
        </Typography>
        {order?.buyer?.social_reason && (
          <Typography variant="body1" sx={{ color: '#444', fontWeight: 'normal', mb: 0.25, fontSize: '0.9rem' }}>
            {order.buyer.social_reason}
          </Typography>
        )}
        {order?.client_ref && (
          <Typography variant="body2" sx={{ color: '#666', mb: 0.25, fontSize: '0.85rem' }}>
            {order.client_ref}
          </Typography>
        )}
        <Typography variant="caption" sx={{ color: '#888', fontSize: '0.75rem' }}>
          Generated on {currentDate}
        </Typography>
      </Box>
      <Divider sx={{ mb: 1.5 }} />
    </Box>
  );
};

export default PrintHeader;